import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    borderRadius: pxToRem(2),
    backgroundColor: theme.palette.neutralLighter,
  },
  text: {
    display: 'inline-block',
    padding: '1px .5rem 3px',
  },
});
